import { render, staticRenderFns } from "./RegisterScreen.vue?vue&type=template&id=05e4ff4e&"
import script from "./RegisterScreen.vue?vue&type=script&lang=ts&"
export * from "./RegisterScreen.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports